export default "__VITE_ASSET__BIiLi5S6__$_?url__"